import { render, staticRenderFns } from "./kapor-form-data.vue?vue&type=template&id=948a5a9e&scoped=true&lang=pug"
import script from "./kapor-form-data.vue?vue&type=script&lang=js"
export * from "./kapor-form-data.vue?vue&type=script&lang=js"
import style0 from "./kapor-form-data.vue?vue&type=style&index=0&id=948a5a9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948a5a9e",
  null
  
)

export default component.exports